/**
 * Created by razial on 21.09.2026.
 */

cleverapps.overrideStyles(cleverapps.styles.ChestTimeMissionWindow, {
    contentPadding: [{
        left: 0,
        right: 0
    }, {
        left: 0,
        right: 500
    }, {
        left: 0,
        right: 600
    }],

    animation: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -55 }
    },

    pack: {
        x: { align: "center", dx: 900 },
        y: { align: "center", dy: -100 },

        title: {
            x: { align: "center" },
            y: { align: "center", dy: 0 },
            noBg: true,

            text: {
                x: { align: "center" },
                y: { align: "center", dy: -330 },
                width: 400
            }
        },

        energyReward: {
            x: { align: "center" },
            y: { align: "center", dy: -220 }
        },

        buyPackButton: {
            x: { align: "center" },
            y: { align: "center", dy: -450 },
            width: 330,
            height: 110
        },

        cooldown: {
            button: {
                x: { align: "center" },
                y: { align: "center", dy: -450 }
            },
            timer: {
                x: { align: "center" },
                y: { align: "center", dy: -545 },
                margin: 8,
                icon: {
                    dx: 5,
                    dy: -3
                }
            }
        }
    },

    description: {
        x: { align: "center" },
        y: { align: "center", dy: -520 }
    }
});
